import { FilterItem, filtersLibrary } from "@/components/filter/filter.types.ts";
import {
  ApiIntegrationEmployeeLinkStatus,
  ApiIntegrationEmployeesFilter,
} from "@/types/integrations/integration.types.ts";
import { CoreFilterType, FilterRenderType, FilterValueType } from "@skailer-com/uikit";
import { ApiFilterBase } from "@skailer-com/uikit/core";
import { useTranslation } from "react-i18next";

export const integrationEmployeesFilterSource = "Integration Employees";

export interface IntegrationEmployeesFilter extends ApiFilterBase {
  text?: string;
  statuses?: ApiIntegrationEmployeeLinkStatus[];
}

export function useIntegrationEmployeesFilters(): FilterItem[] {
  const { t } = useTranslation();
  const library = filtersLibrary();

  return [
    library.page_number,
    library.text,
    {
      name: "statuses",
      type: CoreFilterType.urlParam,
      valueType: FilterValueType.stringArray,
      renderType: FilterRenderType.multiselect,
      label: t("common:status"),
      options: [
        {
          id: ApiIntegrationEmployeeLinkStatus.linked,
          title: t("integrations:employee_link_status_linked"),
        },
        {
          id: ApiIntegrationEmployeeLinkStatus.not_found,
          title: t("integrations:employee_link_status_not_found"),
        },
      ],
    },
  ];
}

export function toApiIntegrationEmployeesFilter({
  statuses,
  ...filter
}: IntegrationEmployeesFilter): ApiIntegrationEmployeesFilter {
  // Бэк принимает один статус: оба выбранных статуса — это весь список
  return { ...filter, status: statuses?.length === 1 ? statuses[0] : undefined };
}
